import { Component } from '@angular/core';

@Component({
  template: '<router-outlet></router-outlet>',
    
})
/** BaseGroup component*/
export class BaseGroupComponent {
    /** BaseGroup ctor */
    constructor() {

    }
}
